import httpClient from "./httpClient";

/**
 * Generation and editing both run one or more Gemini image calls server
 * side, which routinely takes longer than the shared 10s default — and a
 * retried image call would burn another 20-40s and, for `generate`, produce
 * duplicate concepts. Both calls opt out of the shared retry policy and set
 * their own generous per-call timeout instead.
 */
export const logoApi = {
  generate: (payload) =>
    httpClient.post("/logos/generate", payload, {
      timeout: 60000,
      maxRetries: 0,
    }),

  edit: (payload) =>
    httpClient.post("/logos/edit", payload, { timeout: 45000, maxRetries: 0 }),
};
